<template>
  <div>

    <Breadcrumbs :children="[
      {
        text: 'Drivers',
        link: 'lo-primo'
      },
      {
        text: driver.name || '...'
      }
    ]" />

    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else>
      <div class="card ml-3">
        <div class="card-body" style="display:flex">
          <div class="pic">
            <img :src="driver.photo || '/logo_blue.png'" alt="Driver photo">
          </div>
          <div class="info p-3">
            <h5>{{ driver.name + '' + (driver.lastName || '')}}</h5>
            <p><i class="fa fa-phone mr-1"></i>{{ driver.mobile_number || 'N/A' }}</p>
            <p><i class="fa fa-envelope mr-1"></i>{{ driver.email || driver.id }}</p>
            <p><i class="fa fa-user-circle mr-1"></i>{{ driver.document_number || 'N/A' }}</p>

          </div>
        </div>
      </div>

      <div class="ml-15 mt-2">

        <div class="card">
          <div class="card-body">
            <h5>Ordenes</h5>

            <div style="max-height:45vh;overflow-y:auto;">
              <table class="table">
                <thead class="thead-light">
                  <tr>
                    <th>Número</th>
                    <th>Fecha</th>
                    <th>Sucursal</th>
                    <th>Cliente</th>
                    <th>Total</th>
                    <th>Estado</th>
                  </tr>  
                </thead>
                <tbody>
                  <tr v-for="x in driverOrders" :key="x.id">
                    <td>{{ x.number }}</td>
                    <td>{{ x.date || '' }}</td>
                    <td>{{ x.branchOfficeName }}</td>
                    <td>{{ x.client }}</td>
                    <td>{{ x.total | money }}</td>
                    <td>{{ x.status }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs'
import Loader from '../components/Loader'
import { DriverService } from '../../services/DriverService';

export default {
  name: 'DriverDetails',
  components: { Breadcrumbs,Loader },
  data:function(){
    return {
      loading: false,
      driverService: new DriverService(),
      driverOrders: [],
      driver: {}
    }
  },
  methods: {
    async getUsers(){
      this.loading = true;
      const res = await this.driverService.getUsers();
      if(res.ok){
        this.users = res.users;
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      this.loading = false;
    },
    async getOrders(){
      const res = await this.driverService.getDriverOrders(this.$route.params.id);
      this.driverOrders = res.data;
      console.log(res);
    },
  },
  beforeMount: async function() {
    this.loading = true;
    const res = await this.driverService.getDriver(this.$route.params.id);
    if(res.ok){
      this.driver = res.data;
    }else{
      this.$helpers.message('Error', res.message, 'error');
    }
    await this.getOrders();
    this.loading = false;
  }
}
</script>

<style lang="scss" scoped>
.pic{
  height: 175px;
  width: 175px;
  text-align: center;
  img{
    height: inherit;
    width: auto;
  }
}
th,td{
  font-weight: 400;
}
</style>